<template>
  <div class="user-invite">
    <!-- style="width: 100%; max-width: 400px; display: flex;" -->
    <div class="p-2">
      <h3 v-if="headline">{{headline}}</h3>
      <!-- TODO: list of user -->

      <!-- TODO: Bug: beim ersten öffnen muss mal 2x clicken -->
      <el-form :model="userForm" :rules="rules" ref="form" >
        <!-- <el-form-item label="Email" prop="email">
          <el-input v-model="userForm.email" placeholder="Enter username or email address">
        </el-form-item> -->

        <div style="display: flex">
          <!-- :loading="loading" -->
          <el-form-item
            prop="userSearchInput"
            :class="{ 'mr-2': invitationType !== 'Goalpilot', 'w-100': true }">
            <el-select
              ref="input"
              v-model="userForm.userSearchInput"
              value-key="id"
              reserve-keyword
              multiple
              filterable
              allow-create
              remote
              default-first-option
              :remote-method="remoteMethod"
              placeholder="Enter username or email address"
              style="width: 100%"
              @keyup.native.tab="onPressTab"
              @change="onChange">
              <el-option
                v-for="item in options"
                :key="item.$key"
                :label="item.label"
                :value="item"
                style="height: 50px; display: flex; align-content: flex-start; width: 100%; align-items: center;">
                  <!-- style="margin-right: 4px; border-radius: 100%;" -->
                <img
                  class="mr-1 avatar"
                  :src="item.profilePic | defaultUserPic"
                  width="32"
                  height="32" />
                <div><strong>{{ item.label }}</strong></div>
                <!-- <span style="font-size: 9pt">{{ item.$id }}</span> -->
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item prop="permissionLevel" style="flex: 0 0 100px" v-if="invitationType !== 'Goalpilot'">
            <el-select v-model="userForm.permissionLevel" disabled>
              <el-option label="can view" :value="1"></el-option>
              <el-option label="can edit" :value="2"></el-option>
            </el-select>
          </el-form-item>
        </div>

        <!--
        <el-form-item prop="email">
          <el-autocomplete
            :size="size"
            style="width: 100%;"
            v-model="userForm.email"
            :fetch-suggestions="querySearchAsync"
            :trigger-on-focus="false"
            clearable
            placeholder="Enter username or email address">
            <template slot-scope="{ item }">
              <div style="padding: 5px 0; line-height: 1.4em;">
                {{ item.displayName }}<br />
                <img
                  style="margin-right: 4px; border-radius: 100%;"
                  :src="item.profilePic"
                  width="16"
                  height="16" />
                <span style="font-size: 9pt">{{ item.value }}</span>
              </div>
            </template>
            <el-select v-model="userForm.permissions" style="width: 100px" slot="append">
              <el-option label="can view" :value="1"></el-option>
              <el-option label="can edit" :value="2"></el-option>
            </el-select>
          </el-input>
          </el-autocomplete>
        </el-form-item>
        -->

        <el-form-item prop="personalMessage">
          <el-input type="textarea" v-model="userForm.personalMessage" placeholder="Optional: Add a personal note"></el-input>
        </el-form-item>

        <el-button type="primary" @click="onInviteUserByEmail">
          Send invitation {{ selectionContainsEmails ? 'as email' : ''}} or add as contact
        </el-button>

        <el-checkbox class="ml-0 mt-1" v-model="userForm.sendCopy" :disabled="!selectionContainsEmails">Send copy to myself</el-checkbox>
        <!-- <el-checkbox v-model="dont_add_as_friend">Don't add as friend</el-checkbox> -->
      </el-form>

      <!-- <pre class="mini-pre mt-4">{{userForm}}</pre> -->
    </div>
  </div>
</template>

<script>
import isEmail from 'validator/lib/isEmail';

// TODO: https://element.eleme.io/#/en-US/component/select#remote-search ?
// TODO: Allow multiple users

// TODO: Avoid displaying sensitive information aka. email addresses her
// TODO: Use username instead

// var validateEmail = (rule, value, callback) => {
//   if ( isEmail(value)) {
//     callback();
//   } else {
//     callback(new Error('Please provide a valid email address'));
//   }
// };

export default {
  props: {
    size: { default: 'normal' },
    headline: { default: 'Invite team members' },
    invitationType: {
      default: 'Goalpilot',
      validator(value) {
        const allowed_props = [
          'Visionboard',
          'Goal',
          'Sequence',
          'Challenge',
          'Goalpilot'
        ];
        return process.env.NODE_ENV !== 'production'
          ? allowed_props.indexOf(value) !== -1
          : true
      }
    },
    invitationPayload: { default: null },
  },
  data: () => ({
    options: [],
    loading: false,
    // dont_add_as_friend: false,
    userForm: {
      userSearchInput: [],
      // email: '',
      permissionLevel: 2, // 'view',
      personalMessage: '',
      sendCopy: false,
    },
    rules: {
      // email: [
      //   { validator: validateEmail, trigger: 'blur' /*'change'*/ }
      // ],
      userSearchInput: [
        {
          validator: (rule, list, callback) => {
            let error_list = []
            list.forEach( value => {
              if ( typeof value === 'object' ) {
                /* skip autocomplete results */
                return
              }
              if ( !isEmail(value) ) {
                error_list.push( new Error('Please provide a valid email address: ' + value) )
              }
            })
            return error_list.length > 0 ? callback(error_list) : callback();
          },
          trigger: 'change'
        }
      ],
    }
  }),
  computed: {
    selectionContainsEmails() {
      return this.userForm.userSearchInput.some(value => typeof value !== 'object' )
    }
  },
  methods: {
    onPressTab(e) {
      let hoverIndex = this.$refs.input.hoverIndex;
      if ( hoverIndex === 0 ) {
        let query = this.$refs.input.query;
        if ( query && query.trim() !== "" ) {
          this.userForm.userSearchInput.push(query.trim())
        }
      }
      if ( hoverIndex > 0 ) {
        let option = this.options[ hoverIndex - 1 ]
        console.log("onPressTab - adding option", hoverIndex, option)
        if ( option ) {
          if ( this.userForm.userSearchInput.some( existing => existing.id === option.id ) ) {
            return
          }
          this.userForm.userSearchInput.push(option)
        }
      }
    },

    querySearchAsync(queryString, cb) {
      if ( queryString.length > 2 ) {
        this.$api.contact_query_by_string(queryString).then(cb);
      } else {
        cb([])
      }
    },

    remoteMethod(queryString) {
      // TODO: Debounce
      if (queryString !== '' && queryString.length > 3) {
        this.loading = true;
        this.$api.contact_query_by_string(queryString).then(list => {
          if ( list[0].value === 'No match' ) {
            list = []
          }
          // list = list.map(v => ({ ...v, label: v.displayName }))
          this.options = list;
          this.loading = false;
        })
      } else {
        this.options = [];
      }
    },

    onChange() {
      this.$refs.input.previousQuery = '' // Undocumented Element UI feature
      this.$refs.input.query = '' // Undocumented Element UI feature
      // this.$refs.input.visible = false // Undocumented Element UI feature
      // this.$nextTick(() => {
      //   this.$refs.input.focus()
      // })
      this.options = [];
    },

    // onUserHandleSelect(selection) {
    //   console.log("user-invite: onUserHandleSelect", selection);
    //   /* TODO: Hier wird user direkt hinzugefügt. Allerdings wird das Dokument
    //   erst bei save gespeichert. Das führt ggf. zu Verwirrungen. */
    //
    //   if ( selection === 'No match' ) { return };
    //
    //   this.userForm.email = '';
    //
    //   /* If user has no name yet use email instead */
    //   if ( !selection.displayName || selection.displayName === 'N/A' ) {
    //     selection.displayName = selection.email;
    //   }
    //
    //   this.$emit('select', selection)
    // },

    onInviteUserByEmail() {
      /* Only creates an invitation, does not give permissions! */

      this.$refs.form.validate((valid) => {
        if ( !valid ) {
          this.$message.error('Please provide a valid email address.')
          return
        }

        const onSuccess = () => {
          this.$message('User successfully invited');
          this.$emit('done')
        }

        const onError = (error) => {
          this.$message.error('Error while inviting user');
          console.warn(error)
        }

        this.userForm.userSearchInput.forEach(user => {
          if ( typeof user === 'object' ) {
            this.$api.invitation_send_to_existing_user({ // also send an email
              type:            this.invitationType,
              payload:         this.invitationPayload,
              personalMessage: this.userForm.personalMessage.trim(),
              sendCopy:        this.userForm.sendCopy,
              receiverUserId:  user.$id,
              receiverEmail:   user.email,
            }).then(() => {
              this.$refs.form.resetFields();

              // Remove?
              this.$emit('invitation-send', {
                existing_user: true,
                level: this.userForm.permissionLevel,
                userId: user.$id
              })

              if ( this.invitationType === 'Goal' ) {
                // We can handle this client side for now
                this.addExistingMemberToGoal(user.$id)
              }

              if ( this.invitationType === 'Goalpilot' ) {
                this.$api.contact_add({ contactUserId: user.$id })
              }

              onSuccess();
            }).catch(onError)
          } else {
            this.$api.invitation_send_by_mail({
              type:            this.invitationType,
              payload:         this.invitationPayload,
              personalMessage: this.userForm.personalMessage.trim(),
              sendCopy:        this.userForm.sendCopy,
              receiverEmail:   user,
              // ---
              permissionLevel: this.userForm.permissionLevel,

            }).then(() => {
              this.$refs.form.resetFields();
              onSuccess();

              // this.$emit('invitation-send', {
              //   existing_user: false,
              //   level: this.userForm.permissionLevel
              // })
            }).catch(onError)
          }
          // PROBLEM: HOW CAN WE GIVE ACCESS TO USER IF HE DOES NOT EXIST YET? -> CF
        })

        // this.userForm.email = ''
      });
    },

    addExistingMemberToGoal(userId) {
      console.log("addExistingMemberToGoal", userId);
      /* TODO: Goal: Hier wird user direkt hinzugefügt. Allerdings wird das Dokument
      erst bei save gespeichert. Das führt ggf. zu Verwirrungen. */

      this.$api.goal_add_member({
        goal_id: this.invitationPayload.goalId,
        user_id: userId,
      }).then(result => {
        if ( result.message ) {
          this.$message( result.message )
        }
        console.log("added user", result);
        // let addedUser = result.pop()
        // this.fullGoalClone.members.push({
        //    id: selection.id,
        //    ...addedUser // TODO
        // });
      })
    },

    reset() {
      this.$refs.form.resetFields();
    }
  },
}
</script>
